import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";

const Login = () => {
  const [usuario, setUsuario] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");

  //   const formData = new FormData();
  //   formData.append("usuario", usuario);
  //   formData.append("contraseña", contraseña);

  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/Account/Login`,
  //       formData,
  //       {
  //         headers: { "Content-Type": "multipart/form-data" },
  //         withCredentials: true,
  //       }
  //     );

  //     if (response.status === 200) {
  //       localStorage.setItem("lider", usuario);
  //       navigate("/menu");
  //     }
  //   } catch (error) {
  //     console.error("Error en el login:", error);
  //     setError("Usuario o contraseña incorrectos.");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const formData = new FormData();
    formData.append("usuario", usuario);
    formData.append("contraseña", contraseña);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Account/Login`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        const { liderId, nombreLider } = response.data; //  Revisamos qué devuelve el backend

        console.log("✅ Datos recibidos:", response.data); //  Depuración
        console.log("✅ Guardando en localStorage:", liderId, nombreLider);

        localStorage.setItem("liderId", liderId); //  Guardamos el ID del líder
        localStorage.setItem("lider", nombreLider); //  Guardamos el nombre del líder

        navigate("/menu");
      }
    } catch (error) {
      console.error("❌ Error en el login:", error);
      setError("Usuario o contraseña incorrectos.");
    }
  };



  return (
    <div className="wrapper">
      <div className="form-box">
      <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
        <h2>Inicio de Sesión</h2>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-box">
            <input
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              required
            />
            <label>Usuario</label>
          </div>
          <div className="input-box">
            <input
              type="password"
              value={contraseña}
              onChange={(e) => setContraseña(e.target.value)}
              required
            />
            <label>Contraseña</label>
          </div>
          <button type="submit" className="btn">Iniciar Sesión</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
